module.exports = __webpack_public_path__ + "b268021a705732579435624bcce58508.svg";